var map = {
	"./Dashboard/avatar.svg": "b183",
	"./Dashboard/engine-home.png": "8775",
	"./Dashboard/finalOrder.svg": "6cd4",
	"./Dashboard/notFound.svg": "757d",
	"./Dashboard/progressOrder.svg": "c29f",
	"./Dashboard/totalOrder.svg": "9e4b",
	"./IOT.webp": "59cd",
	"./Login/login-bg.png": "f8cf",
	"./brand/vino-app-icon.svg": "7b98",
	"./brand/vino-logo-dark.svg": "0ef4",
	"./brand/vino-logo-light.svg": "de1a",
	"./brand/vino-mark.svg": "8ba8",
	"./iconPack/Lead.svg": "28f9",
	"./iconPack/Stal-line.svg": "969f",
	"./iconPack/Star-filled.svg": "24ba",
	"./iconPack/Star_line.svg": "2423",
	"./iconPack/Star_solid.svg": "4317",
	"./iconPack/actions.png": "b077",
	"./iconPack/arrow-active.svg": "9157",
	"./iconPack/arrow-inactive.svg": "5d56",
	"./iconPack/auth-img.svg": "84cc",
	"./iconPack/basil_edit-outline.svg": "25d5",
	"./iconPack/carbon_warning-square.svg": "9349",
	"./iconPack/charm_tick.svg": "e2fe",
	"./iconPack/credit-card.svg": "db51",
	"./iconPack/dashboard.png": "5b2d",
	"./iconPack/dashboard.svg": "79e8",
	"./iconPack/delete-v2 2.svg": "b682",
	"./iconPack/delete-v2.svg": "5800",
	"./iconPack/deliver.svg": "61cf",
	"./iconPack/edit1.png": "7ad8",
	"./iconPack/excel.svg": "981f",
	"./iconPack/eye.svg": "35f9",
	"./iconPack/format-list-group.svg": "0230",
	"./iconPack/guide.svg": "771d",
	"./iconPack/headphones.svg": "d0e5",
	"./iconPack/humberger-menu.svg": "a033",
	"./iconPack/ic_round-headset-mic-yellow.svg": "5e3b",
	"./iconPack/ic_round-headset-mic.svg": "f5fe",
	"./iconPack/lock.svg": "46b6",
	"./iconPack/material-symbols_folder-open-outline-rounded.svg": "8f86",
	"./iconPack/mdi_format-list-group-plus.svg": "3a84",
	"./iconPack/mdi_format-list-group.svg": "3a4a",
	"./iconPack/mdi_person-multiple.svg": "6089",
	"./iconPack/notification.svg": "e61d",
	"./iconPack/outline-insert-comment.svg": "1fa4",
	"./iconPack/outline-mode-comment.svg": "0ec9",
	"./iconPack/pakshoma/shop-pa.svg": "6d7e",
	"./iconPack/pakshoma/user-pa.svg": "0395",
	"./iconPack/pakshoma/visits-pa.svg": "72d4",
	"./iconPack/person-multiple.svg": "3c08",
	"./iconPack/plus-black.svg": "66df",
	"./iconPack/plus-green.svg": "6bd5",
	"./iconPack/plus-square.svg": "d195",
	"./iconPack/plus-white.svg": "8e5b",
	"./iconPack/plus.svg": "a700",
	"./iconPack/red-trash.svg": "7150",
	"./iconPack/refresh-white.svg": "5f88",
	"./iconPack/refresh.svg": "76bf",
	"./iconPack/relocate.svg": "4edf",
	"./iconPack/search-black.svg": "b29d4",
	"./iconPack/search-white.svg": "29d0",
	"./iconPack/select-project.svg": "5b2d2",
	"./iconPack/shopping-bag.svg": "1015",
	"./iconPack/solar_add-square-broken.svg": "7ddf",
	"./iconPack/solar_play-broken.svg": "1040",
	"./iconPack/tabler_send.svg": "c9ad",
	"./iconPack/tick.svg": "3a95",
	"./iconPack/transaction.svg": "05ba",
	"./iconPack/trash-icon.png": "4378",
	"./iconPack/trash.png": "9584",
	"./iconPack/uil_calender-yellow.svg": "dea0",
	"./iconPack/uil_calender.svg": "2d9a",
	"./iconPack/upload.svg": "fa35",
	"./iconPack/upload_noback.svg": "7514",
	"./iconPack/use.svg": "00c4",
	"./iconPack/user-menu.svg": "058a",
	"./iconPack/user.svg": "5b2f",
	"./iconPack/warning.svg": "29ca",
	"./loading.gif": "12ae",
	"./login-background.png": "98aa",
	"./logo.svg": "e347",
	"./logo1.png": "b189",
	"./myLocation.svg": "d07d",
	"./no_data_img.png": "c9d1",
	"./table-loading.gif": "a7aa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";